const states = [
    {"id": 0, "state": "Alabama"},
    {"id": 1, "state": "Alaska"},
    {"id": 2, "state": "Arizona"},
    {"id": 3, "state": "Arkansas"},
    {"id": 4, "state": "California"},
    {"id": 5, "state": "Colorado"},
    {"id": 6, "state": "Connecticut"},
    {"id": 7, "state": "Delaware"},
    {"id": 8, "state": "Florida"},
    {"id": 9, "state": "Georgia"},
    {"id": 10, "state": "Hawaii"},
    {"id": 11, "state": "Idaho"},
    {"id": 12, "state": "Illinois"},
    {"id": 13, "state": "Indiana"},
    {"id": 14, "state": "Iowa"},
    {"id": 15, "state": "Kansas"},
    {"id": 16, "state": "Kentucky"},
    {"id": 17, "state": "Louisiana"},
    {"id": 18, "state": "Maine"},
    {"id": 19, "state": "Maryland"},
    {"id": 20, "state": "Massachusetts"},
    {"id": 21, "state": "Michigan"},
    {"id": 22, "state": "Minnesota"},
    {"id": 23, "state": "Mississippi"},
    {"id": 24, "state": "Missouri"},
    {"id": 25, "state": "Montana"},
    {"id": 26, "state": "Nebraska"},
    {"id": 27, "state": "Nevada"},
    {"id": 28, "state": "New Hampshire"},
    {"id": 29, "state": "New Jersey"},
    {"id": 30, "state": "New Mexico"},
    {"id": 31, "state": "New York"},
    {"id": 32, "state": "North Carolina"},
    {"id": 33, "state": "North Dakota"},
    {"id": 34, "state": "Ohio"},
    {"id": 35, "state": "Oklahoma"},
    {"id": 36, "state": "Oregon"},
    {"id": 37, "state": "Pennsylvania"},
    {"id": 38, "state": "Rhode Island"},
    {"id": 39, "state": "South Carolina"},
    {"id": 40, "state": "South Dakota"},
    {"id": 41, "state": "Tennessee"},
    {"id": 42, "state": "Texas"},
    {"id": 43, "state": "Utah"},
    {"id": 44, "state": "Vermont"},
    {"id": 45, "state": "Virginia"},
    {"id": 46, "state": "Washington"},
    {"id": 47, "state": "West Virginia"},
    {"id": 48, "state": "Wisconsin"},
    {"id": 49, "state": "Wyoming"}
];


export {
    states
};